import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';

/**
 * Minimal shape of flarum/tags' Tag model that this source relies on.
 * Kept local (instead of importing the real model) since it's the only
 * cross-extension dependency and duck-typing avoids wiring up flarum/tags'
 * dist-typings in this package's tsconfig.
 */

export default class GlobalTagsSearchSource {
  results = (() => new Map())();
  resource = 'tags';
  title() {
    return extractText(app.translator.trans('hli-tag-search.forum.search_source.tags.heading'));
  }
  isCached(query) {
    return this.results.has(query.toLowerCase());
  }
  async search(query, limit) {
    query = query.toLowerCase();
    this.results.set(query, []);
    const params = {
      filter: {
        q: query
      },
      page: {
        limit
      }
    };
    return app.store.find('tags', params).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    return (this.results.get(query) || []).map(tag => {
      const color = tag.color();
      return m("li", {
        className: "TagSearchResult",
        "data-index": 'tags' + tag.id(),
        "data-id": tag.id()
      }, m(Link, {
        href: app.route('tag', {
          tags: tag.slug()
        })
      }, m("span", {
        className: "TagSearchResult-color",
        style: color ? {
          backgroundColor: color
        } : undefined
      }), m("span", {
        className: "TagSearchResult-name"
      }, tag.name()), m("span", {
        className: "TagSearchResult-count"
      }, app.translator.trans('hli-tag-search.forum.search_source.tags.discussion_count', {
        count: tag.discussionCount()
      }))));
    });
  }
  customGrouping() {
    return false;
  }
  fullPage() {
    return null;
  }
  gotoItem(id) {
    const tag = app.store.getById('tags', id);
    if (!tag) return null;
    return app.route('tag', {
      tags: tag.slug()
    });
  }
}
flarum.reg.add('hli-tag-search', 'forum/components/GlobalTagsSearchSource', GlobalTagsSearchSource);